module.exports = __webpack_public_path__ + "static/media/p1.8a513107.png";